import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIconPlaybackRate3X = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 14, viewBox: "0 0 22 14", fill: "none", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.68821 14C4.6147 14 3.66096 13.8159 2.82699 13.4477C1.99746 13.0751 1.34537 12.5627 0.87072 11.9106C0.470582 11.3609 0.237528 10.7418 0.17156 10.0534C0.150919 9.838 0.328113 9.6616 0.544506 9.6616H3.49452C3.70753 9.6616 3.87368 9.83688 3.94294 10.0383C3.98283 10.1544 4.04114 10.2639 4.11787 10.3669C4.27756 10.571 4.49493 10.7307 4.76996 10.846C5.04499 10.9613 5.35995 11.019 5.71483 11.019C6.0564 11.019 6.35805 10.9591 6.61977 10.8394C6.88149 10.7151 7.08555 10.5444 7.23194 10.327C7.37833 10.1096 7.4493 9.86122 7.44486 9.58175C7.4493 9.30672 7.36502 9.06274 7.19201 8.84981C7.02345 8.63688 6.78612 8.47053 6.48004 8.35076C6.17395 8.23099 5.82129 8.1711 5.42205 8.1711H4.42839C4.21279 8.1711 4.03802 7.99633 4.03802 7.78074V6.00634C4.03802 5.79074 4.21279 5.61597 4.42839 5.61597H5.42205C5.79024 5.61597 6.11407 5.55608 6.39353 5.43631C6.67744 5.31654 6.89702 5.15019 7.05228 4.93726C7.21198 4.72433 7.28961 4.48035 7.28517 4.20532C7.28961 3.93916 7.22528 3.70406 7.0922 3.5C6.95912 3.29594 6.77281 3.13625 6.53327 3.02091C6.29816 2.90558 6.02535 2.84791 5.71483 2.84791C5.37769 2.84791 5.07604 2.90779 4.80988 3.02757C4.54816 3.14734 4.34189 3.31369 4.19106 3.52662C4.11342 3.63623 4.05517 3.75408 4.01632 3.88015C3.95356 4.08384 3.78719 4.25856 3.57405 4.25856H0.810698C0.594293 4.25856 0.417113 4.08213 0.437494 3.86668C0.50132 3.19201 0.723358 2.58626 1.10361 2.04943C1.56052 1.41065 2.18599 0.909379 2.98004 0.545627C3.77408 0.181876 4.68568 0 5.71483 0C6.7218 0 7.61121 0.170786 8.38308 0.512357C9.15938 0.853929 9.76489 1.32414 10.1996 1.923C10.6388 2.51743 10.8561 3.19835 10.8517 3.96578C10.8606 4.72877 10.5989 5.35425 10.0665 5.84221C9.55017 6.31952 8.89799 6.60582 8.10998 6.70113C8.07991 6.70477 8.05703 6.73016 8.05703 6.76045C8.05703 6.79074 8.08003 6.81616 8.11012 6.81966C9.18381 6.94441 9.99343 7.27955 10.539 7.8251C11.0935 8.37516 11.3663 9.06717 11.3574 9.90114C11.3618 10.6996 11.1223 11.4072 10.6388 12.0238C10.1597 12.6404 9.49208 13.1239 8.63593 13.4743C7.78422 13.8248 6.80165 14 5.68821 14Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M15.0186 3.59316C15.1698 3.59316 15.3074 3.68049 15.3718 3.81731L16.4128 6.02937C16.5518 6.32487 16.9706 6.32915 17.1157 6.03655L18.2196 3.81012C18.2855 3.67723 18.421 3.59316 18.5693 3.59316H21.3211C21.6162 3.59316 21.8046 3.90801 21.6651 4.16806L19.3335 8.51443C19.2703 8.63213 19.2717 8.77394 19.3372 8.89035L21.7794 13.2319C21.9257 13.4922 21.7377 13.8137 21.4391 13.8137H18.7212C18.5769 13.8137 18.4445 13.7342 18.3766 13.6069L17.1067 11.2233C16.9587 10.9456 16.5597 10.9481 16.4153 11.2278L15.1891 13.6024C15.1221 13.7322 14.9883 13.8137 14.8422 13.8137H12.0775C11.7782 13.8137 11.5903 13.4908 11.738 13.2306L14.2023 8.88991C14.2682 8.77377 14.2702 8.63198 14.2075 8.51404L11.898 4.16667C11.7598 3.90666 11.9483 3.59316 12.2427 3.59316H15.0186Z", fill: props.fill }));
});
export default SvgIconPlaybackRate3X;
